import { Component, Input } from "@angular/core";

@Component({
    selector: 'bar-chart-summary-counter',
    templateUrl: './barChartSummaryCounter.component.html',
    host: { class: 'global' },
    standalone: false
})
export class BarChartSummaryCounterComponent {
    @Input() public valueA: number = 0;
    @Input() public valueB: number = 0;
}